<!-- <mat-toolbar color="primary" class="app-header">
  <div><a href="https://www.positronx.io" target="_blank" class="positronx">PositronX.io</a></div>
  <span class="nav-tool-items">
    <a mat-button routerLink="login" routerLinkActive="active">Log in</a>
    <a mat-button mat-raised-button routerLink="register" routerLinkActive="active">Register</a>
  </span>
</mat-toolbar> -->
<!-- <app-header navScreen="Home" class="mb-5"></app-header> -->
<router-outlet></router-outlet>
<app-ka-footer [hidden]="checkDashboard"></app-ka-footer>
